<template>
  <div>
    <FileField
      id="item_images[]"
      :form-data="formData"
      :label="optional ? t('label_optional') : t('label')"
      :placeholder="optional ? t('placeholder_optional') : t('placeholder')"
      :min-files="minPhotos"
      :min-files-error="t('min_files_error', { count: minPhotos })"
      :required="!optional"
      accept="image/png,image/jpeg,image/webp"
      multiple
      @files="$emit('files', $event)"
    />
    <p class="mt-2 text-sm text-gray-500">{{ t("hint") }}</p>
    <p v-if="error" class="mt-2 text-sm text-red-600" data-test="photos-error">{{ error }}</p>
  </div>
</template>

<script>
import { FileField } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  components: { FileField },

  props: {
    // Mutated in place by FileField under the `item_images[]` key.
    formData: {
      type: Object,
      required: true,
    },
    minPhotos: {
      type: Number,
      required: true,
    },
    // When editing an existing product, sending new photos is optional: the customer may
    // only be fixing a price. Sending some still requires a full set.
    optional: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
  },

  emits: ["files"],

  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n src="./ProductItemPhotosField.i18n.json"></i18n>
